import { NoInput } from '@models/modal';
import {
  createModalDataToken,
  createModalOpener
} from 'src/app/helpers/create-modal-opener';
import { NotificationsSetupModalComponent } from './notifications-setup-modal.component';

export interface NotificationsSetupModalOutput {
  readonly action: 'save';
}

export const NOTIFICATIONS_SETUP_MODAL_DATA = createModalDataToken<NoInput>(
  'NotificationsSetupModalData'
);

export const notificationsSetupModalOpener = createModalOpener<
  NotificationsSetupModalComponent,
  NoInput,
  NotificationsSetupModalOutput
>(NotificationsSetupModalComponent, NOTIFICATIONS_SETUP_MODAL_DATA, {
  size: 'xl',
  backdrop: 'static'
});
